/**
 * Component to render SCA Governance award page
 */
const GovernanceAwardPage = (): React.ReactElement => {
  return (
    <div
      className="mb-10 font-public-sans"
      data-testid="governance-award-page-component"
    >
      <p>
        <strong>Objectives of the Award</strong>
      </p>

      <p>
        To recognise individuals and/or organisations that have made outstanding
        and exemplary contributions to the cause of corporate governance in
        Singapore.
      </p>

      <p>
        <strong>Selection and Judging Process</strong>
      </p>

      <p>
        This special one-off award was introduced in 2015 for the 10th
        anniversary of the Singapore Corporate Awards.
      </p>

      <p>
        In February 2015, nominations were called for the Distinguished
        Contribution to Corporate Governance Award along with the call for
        nominations of the other Singapore Corporate Award categories.
      </p>

      <p>
        The judges reviewed the nominations and concluded on one nominee which
        they felt stood out among all others – Mr. JY Pillay.
      </p>

      <p>
        <strong>Citation for Mr JY Pillay</strong>
      </p>

      <p>
        The Distinguished Contribution to Corporate Governance Award is
        presented to Mr Joseph Yuvaraj Pillay for his outstanding and sustained
        contributions to governance in the corporate world as well as in the
        public, academic and religious spheres.
      </p>

      <p>
        In the corporate world, Mr JY Pillay led the development of the 2005
        Code of Corporate Governance and helmed the governance of foremost
        corporations such as Singapore Airlines, Singapore Exchange, Development
        Bank of Singapore, and Temasek Holdings.
      </p>

      <p>
        In government, Mr Pillay has spent 34 years in the civil service heading
        government ministries and agencies such as the Monetary Authority of
        Singapore and the Government of Singapore Investment Corporation, and he
        is now Chairman of the Securities Industry Council, and the Council of
        Presidential Advisers.
      </p>

      <p>
        Mr Pillay is presently the Rector of the College of Alice and Peter Tan
        at the National University of Singapore, and sits on the board of
        Autorità di Informazione Finanziaria, the financial regulatory authority
        of the Vatican
      </p>

      <div className="mt-12 text-xs">
        <p>
          For more information, please contact the Singapore Institute of
          Directors:
        </p>

        <ul className="mb-6 list-none">
          <li>Mr Edwin Lee;</li>
          <li>Email: edwin@sid.org.sg;</li>
          <li>DID: 6011 0100 / 6422 1188;</li>
        </ul>

        <ul className="list-none">
          <li>Singapore Institute of Directors;</li>
          <li>168, #11-03 Robinson Rd, Capital Tower, 068912;</li>
        </ul>
      </div>
    </div>
  );
};

export default GovernanceAwardPage;
